import ArchiveIcon from '@mui/icons-material/Archive';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DownloadIcon from '@mui/icons-material/Download';
import EditIcon from '@mui/icons-material/Edit';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PrintIcon from '@mui/icons-material/Print';
import SendIcon from '@mui/icons-material/Send';
import ShareIcon from '@mui/icons-material/Share';
import UploadIcon from '@mui/icons-material/Upload';
import { Box, IconButton, alpha, styled } from '@mui/material';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { red } from '@mui/material/colors';
import * as React from 'react';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

const MenuCardWidget = ({
  onEdit,
  onDelete,
  onAsign,
  onMore,
  onCopy,
  onArchive,
  onDownload,
  onUpload,
  onPrint,
  onSend,
  onShare,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 0,
      }}
    >
      <IconButton
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <MoreVertIcon />
      </IconButton>
      <StyledMenu
        id="demo-customized-menu"
        MenuListProps={{
          'aria-labelledby': 'demo-customized-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {onEdit ? (
          <MenuItem
            onClick={() => {
              onEdit();
              handleClose();
            }}
            disableRipple
          >
            <EditIcon />
            Editar
          </MenuItem>
        ) : null}
        {onDelete ? (
          <MenuItem
            onClick={() => {
              onDelete();
              handleClose();
            }}
            disableRipple
            sx={{ color: red[700] }}
          >
            <DeleteForeverIcon sx={{ color: `${red[700]} !important` }} />
            Eliminar
          </MenuItem>
        ) : null}
        {onAsign ? (
          <MenuItem
            onClick={() => {
              onAsign();
              handleClose();
            }}
            disableRipple
          >
            <AssignmentTurnedInIcon />
            Asignar
          </MenuItem>
        ) : null}

        {onCopy ? (
          <MenuItem
            onClick={() => {
              onCopy();
              handleClose();
            }}
            disableRipple
          >
            <FileCopyIcon />
            Copiar
          </MenuItem>
        ) : null}
        {onDownload ? (
          <MenuItem
            onClick={() => {
              onEdit();
              handleClose();
            }}
            disableRipple
          >
            <DownloadIcon />
            Descargar
          </MenuItem>
        ) : null}
        {onUpload ? (
          <MenuItem
            onClick={() => {
              onUpload();
              handleClose();
            }}
            disableRipple
          >
            <UploadIcon />
            Subir
          </MenuItem>
        ) : null}
        {onPrint ? (
          <MenuItem
            onClick={() => {
              onPrint();
              handleClose();
            }}
            disableRipple
          >
            <PrintIcon />
            Imprimir
          </MenuItem>
        ) : null}
        {onSend ? (
          <MenuItem
            onClick={() => {
              onSend();
              handleClose();
            }}
            disableRipple
          >
            <SendIcon />
            Enviar
          </MenuItem>
        ) : null}
        {onArchive || onMore ? <Divider sx={{ my: 0.5 }} /> : null}
        {onArchive ? (
          <MenuItem
            onClick={() => {
              onArchive();
              handleClose();
            }}
            disableRipple
          >
            <ArchiveIcon />
            Archive
          </MenuItem>
        ) : null}
        {onShare ? (
          <MenuItem
            onClick={() => {
              onShare();
              handleClose();
            }}
            disableRipple
          >
            <ShareIcon />
            Compatir
          </MenuItem>
        ) : null}
        {onMore ? (
          <MenuItem
            onClick={() => {
              onEdit();
              handleClose();
            }}
            disableRipple
          >
            <MoreHorizIcon />
            Más
          </MenuItem>
        ) : null}
        {/* <MenuItem onClick={() => {
          onEdit()
          handleClose()}} disableRipple>
          <FileCopyIcon />
          Duplicate
        </MenuItem>
        <MenuItem onClick={() => {
          onEdit()
          handleClose()}} disableRipple>
          <MoreHorizIcon />
          More
        </MenuItem> */}
      </StyledMenu>
    </Box>
  );
};

export default MenuCardWidget;
